function MgmtTableHead_excel(){

    return(
        <div className="comp_thead comp_tr comp_tr--excel">
            <div className="comp_td"></div>
            {/* <div className="comp_td"><input type="checkbox" /></div> */}
            <div className="comp_td">사번</div>
            <div className="comp_td">아이디</div>
            <div className="comp_td">이름</div>
            <div className="comp_td">직군</div>
            <div className="comp_td">관리자</div>
            <div className="comp_td">경력</div>
            <div className="comp_td">전담여부</div>
            <div className="comp_td">프리셉터</div>
            <div className="comp_td">입사일</div>
            <div className="comp_td">적용 해제일</div>
            <div className="comp_td">메모</div>
        </div>
    )
}

export default MgmtTableHead_excel;